module.exports = __webpack_public_path__ + "media/images/ibu__social__logo__instagram-807db656faa83d1531eb471dd5045cb5.svg";